import React from 'react';
import Head from 'next/head';
import BaseLayout from '@/components/common/BaseLayout';
import faqsConstants from '@/utils/faqs/faqs.constants';
import TAGS from '../../public/headJson.json';
import RouteName from '../utils/route.util';
import Faqs from '../components/Faqs';

const FaqsPage = () => {
  const structData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqsConstants?.faqsData?.map((faq) => {
      return {
        '@type': 'Question',
        name: faq?.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq?.answer,
        },
      };
    }),
  };

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.faq.title}</title>
        <meta name="title" content={TAGS.faq.title} />
        <meta name="description" content={TAGS.faq.desc} />
        <link rel="canonical" href={`${RouteName.faqs}/`} />

        {/* Facebook */}
        <meta property="og:url" content={RouteName.faqs} />
        <meta property="og:title" content={TAGS.faq.title} />
        <meta property="og:description" content={TAGS.faq.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.faqs} />
        <meta property="twitter:title" content={TAGS.faq.title} />
        <meta property="twitter:description" content={TAGS.faq.desc} />
        <script
          key="faq-page"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structData) }}
        />
      </Head>
      <BaseLayout category={undefined}>
        <Faqs />
      </BaseLayout>
    </>
  );
};

export default FaqsPage;
